import CallerPostCodeIsDisplay from './CallerPostCodeIsDisplay'
import CallerPostCodeIsForm from './CallerPostCodeIsForm.container'
import IconTick from 'components/Icons/Tick'
import IconClose from 'components/Icons/Close'
import IconGpsFixed from 'components/Icons/GpsFixed'

export default {
  id: 'caller_post_code_is',
  label: "Caller's postcode is",
  helpUrl: 'https://help.thinkpickle.com.au/flows/conditions/callers-postcode-is',
  icon: IconGpsFixed,
  inputs: [{}],
  outputs: [
    {
      name: 'false',
      label: 'False',
      icon: IconClose,
    },
    {
      name: 'true',
      label: 'True',
      icon: IconTick,
    },
  ],
  display: CallerPostCodeIsDisplay,
  form: CallerPostCodeIsForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/CallerPostCodeIs/index.js